import { Injectable } from '@angular/core';
import { FormsValidatorsService } from '@nrwl/rx-forms-dialog-config';
import { DialogsConfigService } from '../dialogs-config.service';

@Injectable({
  providedIn: 'root',
})
export class AuditLogsDialogConfigService extends DialogsConfigService {
  constructor(public formsValidatorsService: FormsValidatorsService) {
    super();
  }

  public showLogDetails(id: number) {
    return {
      payload: {
        title: 'Log Details',
        buttons: this.SubmitButton('Close'),
        data: id,
      },
    };
  }
}
